// URL allowlist used by ChatMarkdown. Pulled out of the React component
// so unit tests can import it without dragging react-markdown (ESM-only,
// not transformable by our jest config) into the test runner.
//
// Security-critical: the LLM emits markdown that could contain arbitrary
// <a href> or <img src>. Anything outside these prefixes renders as
// plain text.

export const internalObjectPattern = /^\/objects\/[0-9a-f-]{36}/iu;
export const internalSurveyPattern = /^\/surveys\/[0-9a-f-]{36}/iu;
export const assetDownloadPattern = /^\/api\/assets\/[0-9a-f-]{36}/iu;

export function isAllowedHref(href: string): boolean {
    return internalObjectPattern.test(href) || internalSurveyPattern.test(href) || assetDownloadPattern.test(href);
}

export function isAllowedImageSrc(src: string): boolean {
    return assetDownloadPattern.test(src);
}
